export const formatPhoneDisplay = (digits: string): string => {
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
};

export const phoneToDisplay = (phone: string): string => {
  const digits = phone.replace(/\D/g, '').slice(-10).slice(0, 10);
  return formatPhoneDisplay(digits);
};

export const phoneToDisplayFull = (phone: string, countryCode = '+1'): string => {
  const display = phoneToDisplay(phone);
  return display ? `${countryCode} ${display}` : '';
};

export const phoneToStorage = (display: string): string => {
  const digits = display.replace(/\D/g, '').slice(0, 10);
  if (digits.length === 0) return '';
  return `+1${digits}`;
};
